import axios from 'axios';

export default {
    FETCH_RESOURCES ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('banners/getAllNewsResource')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('resources', JSON.stringify(payload));
                    commit('SET_RESOURCES', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  FETCH_RESOURCES_FOR_SORTING ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get(`banners/getNewsResourceByType/${payload}`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          // localStorage.setItem('resources', JSON.stringify(payload));
          // commit('SET_RESOURCES', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_RESOURCE_ORDERING ({ commit }, payload) {
      console.log('payload to update, payload', payload)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.put(`banners/updNewsResourceDispOrder`, payload).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        console.log('UPDATE_RESOURCE_ORDER response ', response);
        resolve(data);
      }, (error) => {
        commit('TOGGLE_LOADING', false);
        console.log('UPDATE_RESOURCE error ', error);
        reject(error);
      })
    })

  },
    GETSELECTEDRESOURCE({ commit }, resourceId) {
       console.log('resource ID', resourceId)
        commit('TOGGLE_LOADING', true);
        return axios.get(`banners/getAllNewsResource`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;
            console.log('paylaod returned', payload)
            if (payload) {
              let filtered = payload.filter(x => {
                return x.newsResourcesId.toString() === resourceId.toString()
              })
              console.log('filtered record', filtered)
              commit('SET_SELECTED_RESOURCE', filtered[0])
            }
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_RESOURCE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add resource payload : ", payload);
            axios.post('banners/addNewsResources', payload)
                .then((response) => {
                    console.log('ADD_RESOURCE action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_RESOURCE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_RESOURCE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('banners/updateNewsResources', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_RESOURCE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/resources/actions.js